import styled from "styled-components/macro";

export const AddCreatorPageWrapperStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .upload-wrapper {
    display: flex;
    flex-direction: column;

    h1 {
      padding: 16px;
      color: var(--Neutral-100);
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.03px;
    }
  }
  .header-wrapper {
    display: flex;
    align-items: center;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 9;

    .go-back-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 50%;
      cursor: pointer;

      &:hover {
        background-color: var(--Neutral-4);
      }
    }

    .title {
      color: var(--Neutral-100);
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -0.048px;
      padding: 4px;
    }
  }
`;

export const TableWrapperStyles = styled.div`
  .table-header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;

    .title {
      color: var(--Neutral-100);
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.3px;
      padding: 8px;
    }
  }

  .add-creators-history-table {
    height: calc(100vh - 187px) !important;
    margin-bottom: 8px;
  }
`;

export const AddCreatorFormWrapperStyles = styled.div`
  .form-header-wrapper {
    padding: 8px;
    display: flex;
    align-items: center;

    .title {
      color: var(--Neutral-100);
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.3px;
      padding: 8px 0;
    }
  }
  .form-footer-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px;

    button {
      padding: 10px 20px;
    }
  }

  .form-content-wrapper {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .row-group {
      display: flex;
      align-items: stretch;
      gap: 24px;

      .column-group {
        display: flex;
        flex-direction: column;
        gap: 24px;
        width: 50%;
      }
    }

    /* radio input ui styles */
    .radio-input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .radio-input-group {
        display: flex;
        align-items: center;
        gap: 12px 24px;
        flex-wrap: wrap;
        padding: 4px 0;
      }

      .radio-input-item {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;

        color: var(--Neutral-80);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.14px;

        input[type="radio"] {
          cursor: pointer;
          accent-color: var(--Neutral-80);

          &:disabled {
            cursor: not-allowed;
          }
        }
      }
    }
    /* radio input ui styles */
  }
`;

export const PageScrollWrapperStyles = styled.div`
  height: 100%;
  overflow-y: auto;

  /* custom scrollbar */
  &::-webkit-scrollbar {
    display: none;
    height: 6px;
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--Neutral-300);
    border: 1px solid transparent;
    background-clip: content-box;
  }
`;
